// @flow
import $ from 'jquery';
import { imageFormatExtension } from '../../../helpers/fileExtensionHelper';
import { jqueryValidationOptions } from '../../../forms/auto-floating-labels-form';

export default () => {
  $('.user-info-form').validate({
    ...jqueryValidationOptions,
    ignore: [],
    rules: {
      'user[confirmation_email]': {
        requiredWithTrimInput: true,
        regex: /^([\w.%+-]+)@([\w.-]+\.+[\w]{2,})$/,
        remote: '/user/settings/check_email',
      },
      'user[first_name]': {
        requiredWithTrimInput: true,
        maxlength: 255,
      },
      'user[last_name]': {
        requiredWithTrimInput: true,
        maxlength: 255,
      },
      'user[avatar]': {
        filesize: 5242880,
        extension: imageFormatExtension,
      },
      'user[phone_number]': {
        maxlength: 13,
        minlength: 12,
      },
      'user[zip_code]': {
        required: true,
      },
      'user[prefecture]': {
        required: true,
        prefectureFormat: true,
      },
      'user[city]': {
        required: true,
      },
      'user[address]': {
        required: true,
      },
    },
    messages: {
      'user[confirmation_email]': {
        requiredWithTrimInput: 'メールアドレスは必須項目です。',
        regex: 'メールアドレスの形式が正しくありません。',
        remote: 'メールアドレスは既に存在しています。',
      },
      'user[first_name]': {
        requiredWithTrimInput: '名(漢字)は必須項目です。',
        maxlength: '名(漢字)は255文字以下で入力してください。',
      },
      'user[last_name]': {
        requiredWithTrimInput: '姓(漢字)は必須項目です。',
        maxlength: '姓(漢字)は255文字以下で入力してください。',
      },
      'user[avatar]': {
        filesize:
          '5 MB以下のjpgファイル、gifファイルまたはpngファイルをアップロードしてください。',
        extension:
          '5 MB以下のjpgファイル、gifファイルまたはpngファイルをアップロードしてください。',
      },
      'user[phone_number]': {
        maxlength: '電話番号は10桁か11桁で入力してください。',
        minlength: '電話番号は10桁か11桁で入力してください。',
      },
      'user[zip_code]': {
        required: '郵便番号は必須項目です。',
      },
      'user[prefecture]': {
        required: '都道府県は必須項目です。',
      },
      'user[city]': {
        required: '市区町村は必須項目です。',
      },
      'user[address]': {
        required: '住所は必須項目です。',
      },
    },
  });

  $('.user-register-form').validate({
    ignore: [],
    errorPlacement(error, element) {
      error.insertAfter(element);
    },
    rules: {
      'user[first_name]': {
        requiredWithTrimInput: true,
        maxlength: 255,
      },
      'user[last_name]': {
        requiredWithTrimInput: true,
        maxlength: 255,
      },
      'user[zip_code]': {
        requiredWithTrimInput: true,
      },
      'user[prefecture]': {
        requiredWithTrimInput: true,
      },
      'user[city]': {
        requiredWithTrimInput: true,
      },
      'user[address]': {
        requiredWithTrimInput: true,
      },
    },
    messages: {
      'user[first_name]': {
        requiredWithTrimInput: '姓(漢字)は必須項目です。',
        maxlength: '姓(漢字)は255文字以下で入力してください。',
      },
      'user[last_name]': {
        requiredWithTrimInput: '名(漢字)は必須項目です。',
        maxlength: '名(漢字)は255文字以下で入力してください。',
      },
      'user[zip_code]': {
        requiredWithTrimInput: '郵便番号は必須項目です。',
      },
      'user[prefecture]': {
        requiredWithTrimInput: '都道府県は必須項目です。',
      },
      'user[city]': {
        requiredWithTrimInput: '市区町村は必須項目です。',
      },
      'user[address]': {
        requiredWithTrimInput: '住所は必須項目です。',
      },
    },
  });

  $.validator.addMethod(
    'prefectureFormat',
    function() {
      return prefecture.find(a => a.test($('#user_prefecture').val()));
    },
    '都道府県名を漢字で入力してください',
  );

  const prefecture = [
    /^北海道$/,
    /^青森県$|^青森$/,
    /^岩手県$|^岩手$/,
    /^宮城県$|^宮城$/,
    /^秋田県$|^秋田$/,
    /^山形県$|^山形$/,
    /^福島県$|^福島$/,
    /^茨城県$|^茨城$/,
    /^栃木県$|^栃木$/,
    /^群馬県$|^群馬$/,
    /^埼玉県$|^埼玉$/,
    /^千葉県$|^千葉$/,
    /^東京都$|^東京$/,
    /^神奈川県$|^神奈川$/,
    /^新潟県$|^新潟$/,
    /^富山県$|^富山$/,
    /^石川県$|^石川$/,
    /^福井県$|^福井$/,
    /^山梨県$|^山梨$/,
    /^長野県$|^長野$/,
    /^岐阜県$|^岐阜$/,
    /^静岡県$|^静岡$/,
    /^愛知県$|^愛知$/,
    /^三重県$|^三重$/,
    /^滋賀県$|^滋賀$/,
    /^京都府$|^京都$/,
    /^大阪府$|^大阪$/,
    /^兵庫県$|^兵庫$/,
    /^奈良県$|^奈良$/,
    /^和歌山県$|^和歌山$/,
    /^鳥取県$|^鳥取$/,
    /^島根県$|^島根$/,
    /^岡山県$|^岡山$/,
    /^広島県$|^広島$/,
    /^山口県$|^山口$/,
    /^徳島県$|^徳島$/,
    /^香川県$|^香川$/,
    /^愛媛県$|^愛媛$/,
    /^高知県$|^高知$/,
    /^福岡県$|^福岡$/,
    /^佐賀県$|^佐賀$/,
    /^長崎県$|^長崎$/,
    /^熊本県$|^熊本$/,
    /^大分県$|^大分$/,
    /^宮崎県$|^宮崎$/,
    /^鹿児島県$|^鹿児島$/,
    /^沖縄県$|^沖縄$/,
  ];
};
